// extracted by mini-css-extract-plugin
export var emptyState = "_5p-d";
export var statCard = "_5p-c";
export var table = "_5p-0";
export var tableCell = "_5p-4";
export var tableCellClickable = "_5p-5 _5p-4";
export var tableCellDefault = "_5p-6 _5p-4";
export var tableCellEmpty = "_5p-8";
export var tableCellWithValue = "_5p-7";
export var tableContainer = "_5p-e";
export var tableHeaderWeight = "_5p-1";
export var tableHeaderZone = "_5p-2";
export var tableRowHeader = "_5p-3";
export var viewModeButton = "_5p-9";
export var viewModeButtonActive = "_5p-a _5p-9";
export var viewModeButtonInactive = "_5p-b _5p-9";